module.exports = __webpack_public_path__ + "resources/icon-fail.302c6f75a6140e56.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/dialog/img/icon-fail.png
// module id = 500
// module chunks = 0 1 2 3 4